import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    
    // Notifica mudança para o indexed_toggle
    this.notifyChange()
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(".nested-fields")

    // Verifica se é um registo persistido através do campo 'id'
    const idField = wrapper.querySelector("input[name*='[id]']")

    if (idField && idField.value) {
      // Se for um registo existente, marca-o para destruição
      const destroyField = wrapper.querySelector("input[name*='[_destroy]']")
      if (destroyField) {
        destroyField.value = "1"
      }
      wrapper.style.display = "none"
    } else {
      // Se for um novo registo, remove-o do DOM
      wrapper.remove()
    }
    
    // Notifica mudança para o indexed_toggle
    this.notifyChange()
  }

  notifyChange() {
    // Dispara evento customizado para notificar mudanças
    this.containerTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
